module.exports = __webpack_public_path__ + "static/media/icon-general-setting.1433a78e.svg";